module.exports = __webpack_public_path__ + "img/grafico.48717b22.png";